import { RESET_STUDIO_ACTION } from '../consts';
import type { StudioCustomActions } from '../../actions/studio/custom-actions';
import type { BulkCustomAction, CustomActionStatuses, GlobalCustomAction } from '../../types/FieldModel';
import { HYDRATE_STATE } from '../../store/consts';

export interface State {
    global: GlobalCustomAction[];
    bulk: BulkCustomAction[];
    actionStatus: CustomActionStatuses; // up-to-date statuses of action
    executedActions: string[];
}

const getDefaultState = (): State => ({
    global: [],
    bulk: [],
    actionStatus: {},
    executedActions: []
});

const studioCustomActionsReducer = (state = getDefaultState(), action: StudioCustomActions | null): State => {
    switch (action?.type) {
        case 'STUDIO_SET_GLOBAL_CUSTOM_ACTIONS': {
            const { bulk, global } = action.data;
            return {
                ...state,
                global,
                bulk
            };
        }

        case 'STUDIO_SET_CUSTOM_ACTIONS_STATE': {
            return {
                ...state,
                actionStatus: action.data.actionStatus
            };
        }

        case 'STUDIO_SET_EXECUTED_ACTIONS': {
            return {
                ...state,
                executedActions: action.data.actions
            };
        }

        case RESET_STUDIO_ACTION: {
            return getDefaultState();
        }

        case HYDRATE_STATE: {
            return {
                ...getDefaultState(),
                ...(action?.data.studio?.customActions ?? {})
            };
        }

        default: {
            return state;
        }
    }
};

export default studioCustomActionsReducer;

export const localStorePaths = ['customActions.executedActions'];
